module.exports = __webpack_public_path__ + "static/media/y.98a2feda.png";